import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './store';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './Components/ErrorFallback/ErrorFallback';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from './config/msalConfig';


const root = ReactDOM.createRoot(document.getElementById('root'));
const resetAppState = () => {
  window.location.reload();
};

root.render(
      <Provider store={store}>
     <BrowserRouter>
       <ConfigProvider
    theme={{
      token: {
        // Seed Token
        colorPrimary: '#8c34eb',
        borderRadius: 5,
      },
     
     
    }}
  >
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={resetAppState}
    >
      <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
    </ErrorBoundary>
 
    </ConfigProvider>
    </BrowserRouter>
    </Provider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
